import { Component } from "react";
import { ProjectionProviderHistoryType, ProjectionProviderType } from "../enumerators";
import { ProjectionProviderHistoryEntry } from "../results/projection-provider/projectionProviderHistory";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { formatDateTime } from "@app/shared/formatDateTime";
import formatPhoneNumber from "@app/shared/formatPhoneNumber";
import { TimelineEvent } from "@app/shared/timeline/TimelineEvent";

interface ProjectionProviderHistoryEntryProps {
  historyEntry: ProjectionProviderHistoryEntry;
}

export default class ProjectionProviderHistoryEntryDisplay extends Component<ProjectionProviderHistoryEntryProps> {
  constructor(props: ProjectionProviderHistoryEntryProps) {
    super(props);
  }

  public render() {
    const entry = this.props.historyEntry;
    const title = (this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Created || this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned) ? "Created" : "Updated";
    const subtitile = this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned ? "Copied from another project on " : "";

    return (
      <>
        <TimelineEvent
          key={`timelineEvent:${entry.historyEntryTime.valueOf()}`}
          icon={<QesIcon iconName={QesIcons.Calendar} width="24" isDecorative={true} />}
          title={`${title} by ${entry.userName} ${this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned ? "" : "on"}`}
          subtitle={`${subtitile}${formatDateTime(entry.historyEntryTime)}`}
        >
          <dl className="container timeline-container">
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Projection Provider Type:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {ProjectionProviderHistoryEntryDisplay.projectionTypePastTense(entry.projectionProviderType) || <>&nbsp;</>}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Specialty Code:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.specialtyCode || <>&nbsp;</>}
              </dd>
            </div>
            {entry.projectionProviderType == ProjectionProviderType.ExcludeImpact && < div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Exclusion Verified Sources:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.exclusionVerifiedSources.join("; ") || <>&nbsp;</>}
              </dd>
            </div>}
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Phone:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {formatPhoneNumber(entry.phone) || <>&nbsp;</>}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Reason:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.reasonName || <>&nbsp;</>}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Comment:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.reasonDescription || <>&nbsp;</>}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">All Locations:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.allLocations ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>
            {entry.projectionProviderType == ProjectionProviderType.ExcludeImpact && <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">All Projects:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.allProjects ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>}
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">All Specialties:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.allSpecialties ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>
          </dl>
        </TimelineEvent>
      </>
    );
  }

  private static projectionTypePastTense(projectionProviderType: ProjectionProviderType): string {
    switch (projectionProviderType) {
      case ProjectionProviderType.ExcludeImpact:
        return "Excluded";
      case ProjectionProviderType.Target:
        return "Targeted";
      case ProjectionProviderType.Unknown:
        return "Unknown";
    }
  }
}
